export default "__VITE_ASSET__DcvLvekw__"